export class Target {
  id: number;
  name: string;

  constructor(obj: any) {
    this.id =         obj && obj.id;
    this.name =       obj && obj.name           || null;
  }
}
